module.exports = __webpack_public_path__ + "img/ic_kehu.16d25d01.png";